import {useListView} from '../../core/ListViewProvider'
import {ClinicListToolbar} from './ClinicListToolbar'
import {ClinicListGrouping} from './ClinicListGrouping'
import {ClinicListSearchComponent} from './ClinicListSearchComponent'

const ClinicListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <ClinicListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <ClinicListGrouping /> : <ClinicListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {ClinicListHeader}
